import { branch, compose, renderNothing, withProps } from 'recompose'
import { connect } from 'react-redux'
import { fetchAirDna } from 'src/actions/airDna'
import { withElementRef, withOnceFn } from 'src/composables'
import { AirDnaPanel } from 'src/constants/notificationRefs'
import { selectHasRequestDataMap } from 'src/store/selectors/airDna'
import {
  selectStreet,
  selectZipcode,
  selectHomeId
} from 'src/store/selectors/home'

const AirDnaContainer = compose(
  connect(
    state => {
      const homeId = selectHomeId(state)
      return {
        homeId,
        address: selectStreet(state),
        zipcode: selectZipcode(state),
        hasAirDnaData: selectHasRequestDataMap(state)[homeId]
      }
    },
    dispatch => ({
      fetch: (...args) => dispatch(fetchAirDna(...args))
    })
  ),
  withProps(({ address, zipcode, fetch, homeId }) => ({
    fetch: () => fetch(homeId, { address, zipcode })
  })),
  branch(({ homeId }) => !homeId, renderNothing),
  withElementRef(AirDnaPanel),
  withProps(({ hasAirDnaData, fetch }) => ({
    hasData: hasAirDnaData,
    fn: fetch
  })),
  withOnceFn('onEnter')
)

export default AirDnaContainer
